import _parsePhoneNumber, {
  findPhoneNumbersInText as _findPhoneNumbersInText,
  getCountryCallingCode as _getCountryCallingCode,
  AsYouType as _AsYouType
} from 'libphonenumber-js/core'

import metadata from './libphonenumber-js-custom-metadata.json'

function call(func, _arguments) {
  const args = Array.prototype.slice.call(_arguments)
  args.push(metadata)
  return func.apply(this, args)
}

export default function parsePhoneNumber(...args: any[]) {
  return call(_parsePhoneNumber, args)
}

export function findPhoneNumbersInText(...args: any[]) {
  return call(_findPhoneNumbersInText, args)
}

export function getCountryCallingCode(...args: any[]) {
  return call(_getCountryCallingCode, args)
}

export function AsYouType(country: string) {
  return _AsYouType.call(this, country, metadata)
}

AsYouType.prototype = Object.create(_AsYouType.prototype, {})
AsYouType.prototype.constructor = AsYouType
